import ThreeDotsHorizontalIcon from "@redotech/redo-icons/dots-horizontal.svg";
import LinkExternalIcon from "@redotech/redo-icons/link-external-02.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoListDropdown } from "@redotech/redo-web/arbiter-components/list/redo-list-dropdown";
import { memo, useState } from "react";

interface CustomerActionsDropdownProps {
  customerId: number;
  onViewInRecharge: (customerId: number) => void;
}

export const CustomerActionsDropdown = memo(function CustomerActionsDropdown({
  customerId,
  onViewInRecharge,
}: CustomerActionsDropdownProps) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [buttonRef, setButtonRef] = useState<HTMLButtonElement | null>(null);

  const actionItems: RedoListItem<string>[] = [
    {
      type: "text",
      id: "view-customer-in-recharge",
      value: "view-customer-in-recharge",
      text: "View in Recharge",
      leadingItem: { type: "icon", Icon: LinkExternalIcon },
    },
  ];

  return (
    <>
      <RedoButton
        hierarchy="tertiary"
        IconLeading={ThreeDotsHorizontalIcon}
        onClick={() => setDropdownOpen(true)}
        ref={setButtonRef}
        size="xs"
      />
      <RedoListDropdown
        dropdownAnchor={buttonRef}
        dropdownOpen={dropdownOpen}
        items={actionItems}
        itemSelected={({ item }) => {
          if (item.id === "view-customer-in-recharge") {
            onViewInRecharge(customerId);
          }
        }}
        setDropdownOpen={setDropdownOpen}
        size="xs"
      />
    </>
  );
});
